import React from 'react';

import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

import type { SimilarAccountRow } from './types';
import useResultsColumns from './useResultsColumns';

type ResultsGridProps = {
  rows: Array<SimilarAccountRow>;
  title: string;
  subtitle?: string;
};

export default function ResultsGrid({ rows }: ResultsGridProps) {
  const columns = useResultsColumns();

  return (
    <Box sx={{ mb: 3 }}>
      <DataGrid
        autoHeight
        rows={rows}
        columns={columns}
        disableRowSelectionOnClick
        disableColumnMenu
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 25 },
          },
        }}
        pageSizeOptions={[10, 25, 50, 100]}
      />
    </Box>
  );
}
